import { CompanyMergeData, CompanyMergeSchema, EmployeeMergeData, EmployeeMergeSchema, LeadAccountMergeData, LeadAccountMergeSchema, LeadContactMergeData, LeadContactMergeSchema, LeadMergeData, LeadMergeSchema, BasicSiteMergeData, BasicSiteMergeSchema } from '../data';
import { ActivityEntityName } from '../../../../entities';
import { MergeDataset, MergeSource } from '../../decorators';

@MergeDataset({
    entity: ActivityEntityName.Lead
})
export class LeadMergeDataset {

    @MergeSource({
        schema: LeadMergeSchema
    })
    lead: LeadMergeData;

    @MergeSource({
        schema: LeadAccountMergeSchema
    })
    leadAccount: LeadAccountMergeData;

    @MergeSource({
        schema: LeadContactMergeSchema
    })
    leadContact: LeadContactMergeData;

    @MergeSource({
        schema: EmployeeMergeSchema
    })
    leadOwner: EmployeeMergeData;

    @MergeSource({
        schema: CompanyMergeSchema
    })
    leadCompany: CompanyMergeData;

    @MergeSource({
        schema: BasicSiteMergeSchema
    })
    leadSite: BasicSiteMergeData;

}